export enum ObserverEvents {
  LOGOUT = 'logout',
}
